const features = [
  {
    title: '高清不卡顿',
    desc: '全高清画质配合智能CDN加速技术，无论热门剧集还是冷门老片，都能做到不缓冲流畅播放，观影体验始终如一。',
    icon: 'ri-4k-line',
    color: 'primary',
  },
  {
    title: '海量片库',
    desc: '超过10万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日更新，总有你想看的。',
    icon: 'ri-database-2-line',
    color: 'accent',
  },
  {
    title: '全设备兼容',
    desc: '支持电脑、平板、手机全平台访问，无需下载安装任何应用，打开浏览器即可观看，随时随地追剧不设限。',
    icon: 'ri-device-line',
    color: 'secondary',
  },
  {
    title: '完全免费',
    desc: '所有影视内容免费观看，无需注册、无需会员、无需付费。我们坚持免费影视在线观看的理念，让好内容触手可及。',
    icon: 'ri-vip-crown-line',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string }> = {
  primary: { bg: 'bg-primary-50', iconBg: 'bg-primary-100', iconColor: 'text-primary-600' },
  accent: { bg: 'bg-accent-50', iconBg: 'bg-accent-100', iconColor: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-50', iconBg: 'bg-secondary-100', iconColor: 'text-secondary-600' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              平台优势
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              为什么选择51影视
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((feature) => {
              const c = colorMap[feature.color];
              return (
                <div
                  key={feature.title}
                  className={`${c.bg} rounded-xl p-5 md:p-6 border border-transparent hover:border-background-200 transition-colors`}
                >
                  <div className={`w-11 h-11 ${c.iconBg} rounded-xl flex items-center justify-center mb-4`}>
                    <i className={`${feature.icon} ${c.iconColor} text-xl`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {feature.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}